import { CartMutationFieldsFragmentDoc } from '@/gql/graphql'
import { type PromotionTypes } from '@/features/shop/services/Campaigns/types'
import { type FragmentType, getFragmentData } from '@/gql'

export const normalizeGraphQLMutationCart = (
  cart: FragmentType<typeof CartMutationFieldsFragmentDoc>,
) => {
  const { promotions, shopping_cart_lines } = getFragmentData(CartMutationFieldsFragmentDoc, cart)
  return {
    promotions: {
      availablePromotions: (promotions?.availablePromotions ?? []).map((promo) => ({
        ...promo,
        id: promo.promotion_id ? Number(promo.promotion_id) : null,
        // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions -- GQL type is string, cast to PromotionTypes enum
        type: promo.type as PromotionTypes,
        promotion_params: {
          category_id: promo.categoryId ? Number(promo.categoryId) : null,
        },
        thresholds: [{ progress: promo.progress }],
      })),
      dollarTotalQualifyingCredit: (promotions?.dollarTotalQualifyingCredit ?? 0) / 100,
    },
    shopping_cart_lines: shopping_cart_lines
      .filter((line) => 'id' in line.item)
      .map((line) => ({ id: Number(line.item.id) })),
  }
}
